"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserApi = void 0;
exports.createUserApi = (axios) => ({
    findUserByEmail({ email, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`/user/findByEmail`, { email })).data;
        });
    },
    getUserById({ userId }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/user/${userId}`)).data;
        });
    },
    listUsers({ page, searchText, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = {};
            if (page > 0) {
                searchParams.page = page;
            }
            if (searchText && searchText.length > 0) {
                searchParams.searchText = searchText;
            }
            return (yield axios.get('/users', { params: searchParams })).data;
        });
    },
    createUser(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post('/users', props)).data;
        });
    },
    updateUser(_a) {
        var { userId } = _a, rest = __rest(_a, ["userId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/user/${userId}`, rest)).data;
        });
    },
    deleteUser({ userId }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/user/${userId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlckFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvdXNlckFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsYUFBYSxHQUFHLENBQUMsS0FBb0IsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNoRCxlQUFlLENBQUMsRUFDcEIsS0FBSyxHQUdOOztZQUNDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsbUJBQW1CLEVBQUUsRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1FBQ2pFLENBQUM7S0FBQTtJQUVLLFdBQVcsQ0FBQyxFQUFFLE1BQU0sRUFBc0I7O1lBQzlDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsU0FBUyxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1FBQ25ELENBQUM7S0FBQTtJQUVLLFNBQVMsQ0FBQyxFQUNkLElBQUksRUFDSixVQUFVLEdBSVg7O1lBQ0MsTUFBTSxZQUFZLEdBQW9DLEVBQUUsQ0FBQztZQUV6RCxJQUFJLElBQUksR0FBRyxDQUFDLEVBQUU7Z0JBQ1osWUFBWSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7YUFDMUI7WUFFRCxJQUFJLFVBQVUsSUFBSSxVQUFVLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtnQkFDdkMsWUFBWSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7YUFDdEM7WUFFRCxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLFFBQVEsRUFBRSxFQUFFLE1BQU0sRUFBRSxZQUFZLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1FBQ3BFLENBQUM7S0FBQTtJQUVLLFVBQVUsQ0FBQyxLQUtoQjs7WUFDQyxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsSUFBSSxDQUFDLFFBQVEsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUNsRCxDQUFDO0tBQUE7SUFFSyxVQUFVLENBQUMsRUFTaEI7WUFUZ0IsRUFDZixNQUFNLE9BUVAsRUFQSSxJQUFJLGNBRlEsVUFHaEIsQ0FEUTs7WUFRUCxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLFNBQVMsTUFBTSxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7O0tBQ3hEO0lBRUssVUFBVSxDQUFDLEVBQUUsTUFBTSxFQUFzQjs7WUFDN0MsTUFBTSxLQUFLLENBQUMsTUFBTSxDQUFDLFNBQVMsTUFBTSxFQUFFLENBQUMsQ0FBQztRQUN4QyxDQUFDO0tBQUE7Q0FDRixDQUFDLENBQUMifQ==